import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { provideAngularSvgIcon } from 'angular-svg-icon';

import { authInterceptor } from '@core/interceptors/auth-interceptor.interceptor';
import { errorInterceptor } from '@core/interceptors/error-interceptor';
import { userInitializationProvider } from '@core/providers/user-initialization.provider';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    provideAngularSvgIcon(),
    userInitializationProvider,
  ],
};
